/*
 * @Author: your name
 * @Date: 2020-12-30 09:56:16
 * @LastEditTime: 2021-01-07 14:47:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /amc/src/permission.ts
 */
import { CommonMudule } from "@/store/modules/common";
import NProgress from "nprogress";
import { Message } from "element-ui";
import { Route } from "vue-router";
import { UserModule } from "@/store/modules/user";
import router from "@/router/router";
import { parse } from "qs";
import { visitSave } from "@/api/dataObservation";
import { sessionSetItem, sessionGetItem } from "@/utils/baseFn";
import "nprogress/nprogress.css";
let timeCount = 0;
NProgress.configure({ showSpinner: false });
const whiteList = ["/login", "/economyIndex"];
router.beforeEach(async (to: Route, _: Route, next: any) => {
  NProgress.start();
  await CommonMudule.getTenantConfigAction()
  if (UserModule && UserModule.token && UserModule.userInfo.id) {
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done();
    } else {
      if (UserModule.asyncRoute.length === 0) {
        try {
          await CommonMudule.getImgSourceAction();
          await UserModule.GetUserAuthAction();
          await UserModule.GenerateRoutes();
          (router as any).options.routes = UserModule.asyncRoute;
          router.addRoutes(UserModule.asyncRoute);
          next({ ...to, replace: true });
          console.log("router10", router);
          NProgress.done();
        } catch (err) {
          console.log("catch e", err);
          UserModule.ResetToken();
          Message.error(err || "Has Error");
          next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      } else {
        if (!CommonMudule.customerId) {
          if (to.path !== "/userSelect") {
            Message({
              message: "请选择客户",
              type: "error",
              duration: 5 * 1000
            });
            next({ path: "/userSelect" });
            NProgress.done();
          } else {
            next();
            NProgress.done();
          }
        } else {
          next();
          NProgress.done();
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      const params = parse(window.location.href);
      if (params.isDownLoadPage === "true") {
        console.log("params true", params);
        next();
      } else {
        next(`/login?redirect=${to.path}`);
      }

      NProgress.done();
    }
  }
});

router.afterEach((to: Route, from: Route) => {
  console.log(to, from, 323);

  const excludes = ["/login", "/download/index"];
  if (to.meta.code && !excludes.includes(to.path)) {
    setVisitSave(to);
  } else if (from.meta.code && !excludes.includes(from.path)) {
    setVisitSave(from);
  }
  NProgress.done();
  const link: any = document.querySelector(".linkTag");
  if (!link.href.endsWith(".png") || !link.href.endsWith(".ico")) {
    link.rel = "shortcut icon";
    link.type = "image/x-icon";
    link.href = CommonMudule.tenantConfig.titleLogo;
  }
  if (!to.meta.title) {
    document.title = CommonMudule.tenantConfig.title
  } else {
    document.title = to.meta.title;
  }
});

async function setVisitSave(route: Route) {
  // 线上 市场雷达 调用上报接口俩次
  if (+new Date() - timeCount > 1000) {
    timeCount = +new Date();
    try {
      const from = {
        moduleCode: route.meta.code,
        trackId: sessionGetItem("trackId")
      };
      const res = await visitSave(from);
      if (res?.data) {
        sessionSetItem("trackId", res.data.trackId);
      }
    } catch (error) { }
  }
}
